export const CREATE_ORGANIZATION_ERROR = 'Baus/CREATE_ORGANIZATION_ERROR';
